type TouchOrMouseEvent = React.TouchEvent | React.MouseEvent | globalThis.TouchEvent | MouseEvent;

const controller = {
  getPx(val: number): string {
    if (isNaN(val)) {
      return 'auto';
    } else {
      return val + 'px';
    }
  },

  touchY(e: TouchOrMouseEvent): number | null {
    if ('touches' in e && e.touches && e.touches[0]) {
      return e.touches[0].pageY;
    }
    if ('changedTouches' in e && e.changedTouches && e.changedTouches[0]) {
      return e.changedTouches[0].pageY;
    }
    if ('pageY' in e && e.pageY) {
      return e.pageY;
    }
    if ('clientY' in e && e.clientY) {
      return (
        e.clientY + (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop)
      );
    }
    return null;
  },

  touchX(e: TouchOrMouseEvent): number | null {
    if ('touches' in e && e.touches && e.touches[0]) {
      return e.touches[0].pageX;
    }
    if ('changedTouches' in e && e.changedTouches && e.changedTouches[0]) {
      return e.changedTouches[0].pageX;
    }
    if ('pageX' in e && e.pageX) {
      return e.pageX;
    }
    if ('clientX' in e && e.clientX) {
      return (
        e.clientX +
        (document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft)
      );
    }
    return null;
  },
};

export default controller;
